<template>
  <div class="" style="padding:.2rem 0 8rem 0">
  <van-overlay :show="certLoading"    >
      <van-loading type="spinner" v-model="certLoading" style="text-align: center ; margin-top: 200px;" />
  </van-overlay>

  <van-popup v-model="certshow" style="width: 80%; height: auto ; text-align: center">
      <img :src="certUrl"  style="width: 100%; text-align: center; height: auto"  />
      <van-button  v-if="!isApp" style="margin: 10px auto; text-align: center " type="default" round>请长按图片保存</van-button>
      <van-button v-else @click="appDownload(filename,certUrl)" style="margin: 10px auto; text-align: center " type="default" round>点击下载证书</van-button>
  </van-popup>


    <div   v-rblink="{name:'MyClub'}" @click="toMyClub">
<van-notice-bar 
                text="您已具备申请二星俱乐部资质，请尽快升级俱乐部资质。点击前往>>"
                />
    </div>
    <div class="order-success">
      <div class="icon"></div>
      <div class="title">报名成功</div>
      <div class="desc" v-if="row.station.pay_qrcode.length>0">
        <!-- 如果您还未缴纳费用，请扫以下二维码码支付费用{{row.order.pay_price}}元。请勿重复缴费！！！ -->
        如果您还未缴纳费用，请按照通知的要求缴费。请勿重复缴费！！！
        
        <div style="text-align: center">
          <van-button
              style="color: rgb(255, 255, 255); background: linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%); border: 0px;"
              size="normal" round @click="beizhu()">支付成功后，请点这里上传支付凭证
          </van-button> 
        </div>
        <div class="qrcode">
          <img :key="picindex" v-for="(picval,picindex) in row.station.pay_qrcode" :src="picval.url" alt="">
        </div>
        
      </div>
      <div class="desc" v-show="row.station.gametype != 3"><p style="text-align: center">【重要】请仔细阅读下列说明</p>
        <p v-if="row.station_name.indexOf('会议')==-1">1、报名成功后，请务必添加下方培训专属群！</p>
        <!-- <p>加群方式：群二维码截图-打开微信-扫一扫-相册-选择保存的群二维码图片即可</p> -->
        <p v-else>请务必添加所参加会议的群二维码，后续所有参会信息将统一在群中发布。</p>
        <p>加群方式：长按二维码图片或截图后保存至相册→打开微信→点击右上角“+”号→点击“扫一扫”→点击“相册”→选中相应图片</p>
        <p v-show="row.station.is_online == 1">
          2、本次培训含有线上培训内容，啦啦之星平台为指定培训课程平台，请用微信扫描下课程兑换码（本码仅限观看课程《全国啦啦操新周期培训课程》，并非啦啦之星VIP年费会员），方可开始学习；注意：请在有效期内兑换，请用本人微信扫码兑换，一人一码，任何转借、外发，恕不再补；</p>
      </div>
    </div>

    <div v-if="row.saiqu == 692">

    <div class="order-success" v-if="checkImg('全国啦啦操七彩星级工作会议')" >
      <img src="https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1742807684953-6.jpg" />
      <p  >请扫上方二维码进入【七彩星级会议】的群二维码</p>
    </div>
    <div class="order-success" v-if="checkImg('省、市级啦啦操协会工作会议')" >
      <img src="https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1742807684953-8.jpg" />
      <p  >请扫上方二维码进入【省、市级协会会议】的群二维码</p>
    </div>
    <div class="order-success" v-if="checkImg('啦啦操校（局）长工作会议')" >
      <img src="https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1742807684953-10.jpg" />
      <p  >请扫上方二维码进入【校局长论坛】的群二维码</p>
    </div>
    <div class="order-success" v-if="checkImg('省、市级啦啦操协会工作会议')" >
      <img src="https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1742807684953-12.jpg" />
      <p  >请扫上方二维码进入【省级管理单位会议】的群二维码</p>
    </div>
    </div>

    

    <div class="order-success" v-if="row.erweiimg.length>0&&row.saiqu != 692">
      <img :src="row.erweiimg[0].url" />
      <p  >扫码加工作人员好友，进入培训微信群</p>
    </div>

    <div class="order-success" v-if="row.wechat_erweiimg.length>0&&row.saiqu != 692">
      <p  >扫码进入微信群</p>
        <p style="text-align: center;" :key="wechat_erweiimg_key" v-for="(wechat_erweiimg_url,wechat_erweiimg_key) in row.wechat_erweiimg">
          <img style="width: 70%;" :src="wechat_erweiimg_url"  />
        </p>
    </div>

    <van-divider>场次信息</van-divider>
    <van-cell-group>

      <van-cell
          input-align="right"
          title="单位"
          :value="row.danwei"
      />
      <van-cell
          input-align="right"
          title="场次"
          :value="row.station_name"
      />
      <van-cell
          input-align="right"
          title="时间"
          :value="row.station.startdate+'至'+row.station.enddate"
      />
      <van-cell
          input-align="right"
          title="地点"
          :value="row.station.province+'  '+row.station.city+' '+row.station.county"
      />
    </van-cell-group>
    <van-divider>个人信息</van-divider>
    <van-cell-group :key="memberindex" v-for="(membervalue,memberindex) in row.member_list ">
      <van-cell
          input-align="right"
          title="省市区"
          :value="row.province+'  '+row.city+' '+row.county+' '+row.address"
      />
      <van-cell
          input-align="right"
          title="姓名"
          :value="membervalue.name"
      />
      <van-cell
          input-align="right"
          title="身份证号"
          :value="membervalue.num"
      />
      <van-cell
          input-align="right"
          title="手机号"
          :value="membervalue.phone"
      />
      <van-cell
          input-align="right"
            v-if="membervalue.need_jie==1"
          title="接站时间"
          :value="membervalue.jie_date"
      />
      <van-cell
          input-align="right"
            v-if="membervalue.need_jie==1"
          title="接站车次/航班号"
          :value="membervalue.jie_code"
      />
      <van-cell
          input-align="right"
            v-if="membervalue.need_song==1"
          title="送站时间"
          :value="membervalue.song_date"
      />
      <van-cell
          input-align="right"
            v-if="membervalue.need_song==1"
          title="送站车次/航班号"
          :value="membervalue.song_code"
      />
      <van-cell
          input-align="right"
          v-if="membervalue.chengji"
          title="成绩"
          :value="membervalue.chengji"
      />
      <van-cell
          input-align="right"
          v-if="membervalue.score1"
          title="教练考核成绩"
          :is-link="membervalue.score1>60"
          @click="showCert(membervalue,1)"
          :value="membervalue.score1"
      />
      <van-cell
          input-align="right"
          v-if="membervalue.score2"
          :is-link="membervalue.score1>60"
          title="裁判考核成绩"
          @click="showCert(membervalue,2)" 
          :value="membervalue.score2"
      />
    </van-cell-group>

<!--    <van-cell-group>-->

<!--      <van-cell-->
<!--          input-align="right"-->
<!--          title="单位"-->
<!--          :value="row.danwei"-->
<!--      />-->
<!--      <van-cell-->
<!--          input-align="right"-->
<!--          title="场次"-->
<!--          :value="row.station_name"-->
<!--      />-->
<!--      <van-cell-->
<!--          input-align="right"-->
<!--          title="时间"-->
<!--          :value="row.station.startdate+'至'+row.station.enddate"-->
<!--      />-->
<!--      <van-cell-->
<!--          input-align="right"-->
<!--          title="地点"-->
<!--          :value="row.station.province+'  '+row.station.city+' '+row.station.county"-->
<!--      />-->
<!--    </van-cell-group>-->

    <div style="text-align: center">
      <van-button
          style="width: 3rem ; margin: 0 auto"
          size="normal" round @click="goFiles(1)">通知文件下载
      </van-button>
      <van-button
          v-if="row.station.is_daoshi == 1"
          style="width: 3rem ; margin: 0 auto"
          size="normal" round @click="goFiles(2)">导师团
      </van-button>
    </div>
    <div style="margin-top: 10px; text-align: center" v-if="row.file_upload_url"> 

      <van-button 
          style="width: 3rem ; margin: 0 auto"
          size="normal" round @click="fileUrlShow=true">上传报告PPT
      </van-button>
    </div>
    <div style="margin-top: 10px; text-align: center"> 

      <van-button
          v-if="row.station.course_id > 0 || row.station.course_cate_id > 0"
          style="width: 3rem ; margin: 0 auto"
          size="normal" round @click="goCourse()">线上课程学习
      </van-button>
    </div>
    <div style="margin-top: 10px; text-align: center">
      <van-button
          style="width: 3rem ; margin: 0 auto"
          color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
          size="normal" v-if="row.station.can_exame==1" round v-rblink="{name:'HuiyiExame' ,query:{ id:row.id }}">在线考试
      </van-button>
      <van-button
          style="width: 3rem ; margin: 0 auto"
          size="normal" v-if="row.station.need_video==1" round
          v-rblink="{name:'HuiyiApplyFormUploadVideo' ,query:{ id:row.id }}">上传视频
      </van-button>
    </div>
    <div style="margin-top: 10px; text-align: center" v-if="row.station.zips.length>0">  
      <van-button
          style="width: 3rem ; margin: 0 auto"
          size="normal"  round @click="downloadZips()">{{row.station.zips[0].name}}下载
      </van-button>
    </div>

<div :key="examekey" v-for="(examevalue,examekey) in row.station.exame_list">
    <van-divider>在线考试{{examekey+1}}</van-divider>

    <div style="margin-top: 10px; text-align: center">
      <van-button
          style="width: 3rem ; margin: 0 auto"
          color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
          size="normal" @click="goExame(examevalue)"   round>{{examevalue.name}}
           <!-- v-rblink="{name:'H5' ,query:{ url:examevalue.url }}" -->
      </van-button>
      <van-button
          style="width: 3rem ; margin: 0 auto"
          size="normal" v-if="examevalue.need_video" round
          v-rblink="{name:'HuiyiApplyFormExameUploadVideo' ,query:{ id:row.id ,index:examekey+1}}">上传视频
      </van-button>
    </div>
  
</div>

    <div class="order-success" v-if="row.learn_erweima">
      <p v-if="row.erweiimg.length>0">扫码进入小程序,在线学习</p>
      <img :src="row.learn_erweima"/>
    </div>

    <div class="cert-li" v-if="row.cert_url && row.cert_url.url">
      <van-divider>结业证书</van-divider>
      <img :src="row.cert_url.url" alt="">
      <div class="cert-button">
        <van-button v-if="!isApp" style="margin: 10px auto; text-align: center " type="default" round>请长按图片保存
        </van-button>
        <van-button v-else @click="appDownload(row.cert_url.filename,row.cert_url.url)"
                    style="margin: 10px auto; text-align: center " type="default" round>点击下载
        </van-button>
      </div>
    </div>

    <div class="savebtn">
      <van-button
          color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
          style="width: 3rem"
          size="normal" round v-rblink="{name:'HuiyiApplyList'}">我的报名记录
      </van-button>
    </div>

    <van-action-sheet
        v-model="ltShow"
        :actions="ltActions"
        cancel-text="取消"
        @select="onLtSelect"
        close-on-click-action
        @cancel="ltShow=false"
    />

    <van-dialog v-model="fileUrlShow" title="请在复制网址到电脑端操作" confirm-button-text="关闭" >
        <div style="text-align: center; padding:20px 0 ; line-height: 30px ">
            <div
                    v-clipboard:copy="row.file_upload_url"
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onError">
                {{row.file_upload_url}}  <br/> <span  >复制</span>
            </div>
        </div>
    </van-dialog>

  </div>
</template>
<style scoped>
.box {
  /*margin-bottom: 1.5rem;*/
}

.cert-li {
  margin:0 .3rem;
  text-align: center;
}

.cert-li img {
  width: 100%;
  border-radius: 5px;
}

.order-success {
  text-align: center;
  margin: 20px 0;
}

.order-success .icon {
  background: url(../../../assets/images/icon-order-done.png);
  background-size: 100%;
  width: 75px;
  height: 75px;
  margin: 20px auto 20px auto;

}

.order-success .title {
  font-size: 18px;
  font-weight: bold;
  color: #000;
  text-align: center;
}

.order-success .desc {
  padding: 10px;
  text-align: left;
}

.order-success .desc p {
  line-height: 26px;
  font-size: 14px;
  color: #333;
  text-align: left;
}

.order-success img {
  width: 90%;
  /*height: 120px;*/
  margin: 10px auto;
}

.order-success p {
  font-size: 12px;
  color: #999;
}

.sai-shuo-li {
  background: #f3f3f3;
  border-radius: 10px;
  margin: 20px 10px;
  padding: 10px;
}

.sai-shuo-li img {
  width: 50px;
  height: 50px;
  border-radius: 6px;
  float: left;
  margin-right: 10px;
}

.sai-shuo-li .c {
  width: calc(100% - 80px);
  border-right: 1px solid #00000008;
}

.sai-shuo-li .c .title {
  font-size: 14px;
  color: #000;
}

.sai-shuo-li .c .desc {
  font-size: 12px;
  color: #999;
}

.sai-shuo-li .fr {
  width: 70px;
  float: right;
}

.sai-shuo-li .btn {
  width: 60px;
  height: 26px;
  line-height: 26px;
  font-size: 12px;
  text-align: center;
  background: linear-gradient(90deg, rgba(254, 200, 53, 1) 0%, rgba(255, 173, 25, 1) 100%);
  border-radius: 6px;
  color: #fff;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}


</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';
import FileUploader from '@/components/picker/FileUploader.vue';

import {
  Cell,
  Field,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  ActionSheet,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button
} from 'vant';
import CaipanPicker from '@/components/picker/CaipanPicker.vue';
import FamliyPicker from '@/components/picker/FamliyPicker.vue';


import jquery from 'jquery';

jquery.fn.longPress = function (fn) {
  let timeout = 0;
  const $this = this;
  console.log('jquery.fn.longPress')
  for (let i = 0; i < $this.length; i++) {
    $this[i].addEventListener('touchstart', () => {
      timeout = setTimeout(fn, 800); // 长按时间超过800ms，则执行传入的方法
    }, false);
    $this[i].addEventListener('touchend', () => {
      clearTimeout(timeout); // 长按时间少于800ms，不会执行传入的方法
    }, false);
  }
};

Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(ActionSheet).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button);
export default {
  name: 'SaiApplyFormStep2',
  components: {
    [Field.name]: Field,
    PicUploader,
    FileUploader,
  },
  data: function () {
    return {
      ltShow: false,
      ltImgSrc: '',
      certshow:false,
      ltImgName: '',
      certUrl:'',
      ltActions: [{name: '保存图片'}],
      validator,
      saveLoading: false,
      fileUrlShow: false,
      filename:"",
      certLoading:false,
      showFamliyPicker: false,
      showSubjectPicker: false,
      showJiaolianPicker: false,
      showRoomTypePicker: false,
      showMemberPicker: false,
      formData: {
        id: 0
      },
      row: {
        erweiimg: [],
        station_name:'',
        order:{},
        wechat_erweiimg: [],
        station: {
          zips:[],
          pay_qrcode:[]
        },
        member: {},
      },
      isApp: window.isApp()
    }
  },
  filters: {},
  mounted() {
    document.title = '报名成功';
    let that = this;
    that.areaList = area;
    that.formData.id = this.$route.query.id;
    if (that.formData.id) {
      this.fetch();
    }
  },
  watch: {
    formData() {
    }
  },
  destroyed() {
  },
  methods: {
    goExame(row){ 
      console.log('row.url ',row.url )
      // return ;
      rbLink({name:'H5' ,query:{ url:row.url }})
        // appEvent({
        //   name: "downloadFile",
        //   query: { url: row.url },
        // });
    },
    onLtSelect(item) {
      let that = this;
      switch (item.name) {
        case '保存图片':
          let name = that.ltImgSrc.split('?')[0].split('/').pop();
          console.log(that.ltImgSrc, name);
          appEvent({
            name: 'downloadPic',
            query: {
              'filename': name,
              'url': that.ltImgSrc
            }
          });
          break;
      }
    },
    goList() {
      rbLink({name: 'HuiyiApplyList', query: {}}, 'repalce');
    },
    goFiles(type) {
      rbLink({name: 'HuiyiFilesList', query: {station_id: this.row.station.id, type: type}});
    },
    toMyClub(){
      rbLink({name: 'MyClub'});
    },
    goCourse() {
      if(this.row.station.course_cate_id){
        // rbLink({name: 'CourseList', query: {cate_id: this.row.station.course_cate_id}});
        appEvent({
          name: "downloadFile",
          query: { url: 'https://h5.ccachina.net/cca-h5/dist/course-list?show=1&cate_id='+this.row.station.course_cate_id },
        });
      }else{
        rbLink({name: 'CourseDetail', query: {id: this.row.station.course_id}});
      }
    },
    downloadZips(){
        appEvent({
          name: "downloadFile",
          query: { url: this.row.station.zips[0].url },
        });
    },
    onQuestion() {
      console.log('onQuestion')
    },

    appDownload(name, url){
      let that = this;
      console.log('downloadPic');
      appEvent({
        name: 'downloadPic',
        query: {
          filename: name+'.jpg',
          url:url,
        }
      });
    },

    showCert(item,type){
      let that = this
      that.certLoading = true;
      that.$api.post('/api/huiyi/getcert', {
        id:item.id, 
        type:type
      }, (res) => { 
        console.log(res.data)
        that.certshow = true;
        that.certUrl = res.data.url;
        that.filename = res.data.filename;
        that.certLoading = false;
      }, (res) => {
        Toast.fail(res.msg); 
        that.certLoading = false;
      })
    },

    beizhu(){
        rbLink({
            'name' : 'Tpage1',
            'query':{
                id: this.row.id
            }
        } )
    },
    onCopy(e) {
        Toast.success('复制成功');
    },
    onError(e) {
        console.log('复制失败！');
    },
    checkImg(type_name){
      let find = false;
      this.row.member_list.map(member =>{
        member.jsondata['请选择参加的会议'].map(item=>{
          if(item == type_name){
            find = true;
            return ;
          }
        })
      })

      return find;
    },
    fetch() {
      let that = this;
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0
      });
      that.$api.post('/api/huiyi/successdetail', {
        id: that.formData.id
      }, (res) => {
        that.row = res.data;

        Toast.clear()
//                    if(window.isApp()){
        setTimeout(() => {
          jquery('img').each(function () {
            jquery(this).longPress(() => {
              console.log('longPress', jquery(this).attr('src'));
              that.ltImgSrc = jquery(this).attr('src')
              that.ltImgName = jquery(this).attr('title')
              that.ltShow = true;
            });
          })
        }, 500);
        return false;
//                    }


      }, (res) => {
        Toast.fail(res.msg);
      })
    }

  }
}
</script>



// WEBPACK FOOTER //
// HuiyiApplyFormSuccess.vue?1ae2fbfe